import { RootState } from "../..";
export const selectAllApps = (state: RootState) => state.appStore?.data;
export const selectSelectedApp = (state: RootState) => state.appStore?.selectedApp;
export const selectAppStatus = (state: RootState) => state.appStore?.status;
export const selectAppError = (state: RootState) => state.appStore?.error;